/** The panel that renders each stage's section — in the spine, and on every tab of the
 *  tabs view that reaches the stage (a tab renders its part of the stage with it). */
import type { ComponentType } from 'react';

import type { BookingRecordStage } from '@/api/bookingRecord';
import type { ViewSection } from '@/features/records/views/types';

import { AfterTripPanel } from './AfterTripPanel';
import { BookedPanel } from './BookedPanel';
import { CommunicationLane } from './CommunicationLane';
import { DeparturePanel } from './DeparturePanel';
import type { BookingDisplayContext } from './displays';
import { GuestPanel } from './GuestPanel';
import { OnsitePanel } from './OnsitePanel';

export type StagePanelComponent = ComponentType<{
  section: ViewSection<BookingRecordStage>;
  display: BookingDisplayContext;
  /** The panel's width in edit mode (0 = unmeasured) — what a layout inside it follows
   *  in both modes (the guest's contacts rows). */
  editWidth?: number;
}>;

export const STAGE_PANELS: Record<BookingRecordStage, StagePanelComponent> = {
  booked: BookedPanel,
  precheckin: GuestPanel,
  departure: DeparturePanel,
  onsite: OnsitePanel,
  after: AfterTripPanel,
  communication: CommunicationLane,
};
